const TRANSLATIONS_EN = {
    notesFieldLabel: 'Notes'
};

export default TRANSLATIONS_EN;
